import type { ReactNode } from "react";
import { IconFromName } from "../icon/IconSVG";

export interface ICalendarCellIconProps {
  icon: ReactNode;
}

export const CalendarCellIcon = ({ icon }: ICalendarCellIconProps) => {
  return typeof icon === "string" ? <IconFromName icon={icon} /> : icon;
};
